import React, {Fragment, useContext, useEffect, useState} from "react";
import {Collapse} from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Redirect, Route} from "react-router-dom";
import {isMobileOnly, BrowserView, isMobile, MobileView} from 'react-device-detect';

import {BannerHeader} from "../structure";
import {
	countMap,
	extractCartData,
	formatPrice,
	isEmpty,
	mapArrayToObject,
	mapObject,
	mapObjectToArray,
	objLength,
	partitionObject,
} from "../../lib/tools";
import {Button, QtySelector, RelativeSwitch} from "../common/common";
import {Checkbox, DatetimeInput, FormGroup, FormInput, ValidateForm} from "../common/formValidation";
import {reduxWrapper} from "../../globalState";
import {getImage} from "../../lib/api";
import {LoginModal, PromptModal} from './../common/modal';
import {ModalContext} from './../../contexts';

//Icons
import CartIcon from "../../resources/icons/basket-grey.svg";
import SslIcon from "../../resources/icons/ssl.svg";
import CheckWhiteIcon from "../../resources/icons/checkmark-white.svg";
import DropArrowIcon from "../../resources/icons/downArrow-black.svg";
import fragtGreenIcon from "../../resources/icons/fragt-green.svg";
import kalendarGreenIcon from "../../resources/icons/kalender-green.svg";
import cardrGreenIcon from "../../resources/icons/betaling-green.svg";

//Images
import bgImages from "../../resources/images/checkoutBg.jpg";
import moment from 'moment';

const steps = {
	1: "Dine oplysninger",
	2: "Betalingsoplysninger",
	3: "Bekræftelse"
};

export const CheckoutTest = () => {
	return (
		<RelativeSwitch>
			<Route path="brugeroplysninger" render={() => <h1>Levering</h1>}/>
			<Route path="betaling" render={() => <h1>Betaling</h1>}/>
			<Route path="kvittering" render={() => <h1>Kvittering</h1>}/>
			<Route render={() => <Redirect from="/reservere" to="/reservere/brugeroplysninger"/>}/>
		</RelativeSwitch>
	)
};

const ReserveRender =
	({
		 cacheProduct,
		 apiCall,
		 vendors,
		 cart,
		 products,
		 awaitVendors,
		 userId,
		 history,
		 partyInfo
	 }) => {
		
		const [loading, setLoading] = useState(true);
		const [shipping, setShipping] = useState({});
		
		useEffect(() => {
			awaitVendors(v => {
				setShipping(mapObject(v, x => x.shipping.length > 0 ? x.shipping[0].id : null));
				
				apiCall("GET", `/party/current/quote/vendors`)
					.then(data => {
						setShipping(p => mapArrayToObject(data, x => ({
							key: x.id,
							data: p[x.id] || null
						})));
					});
			});
		}, []);
		
		useEffect(() => {
			setLoading(true);
			cacheProduct({
				products: mapObjectToArray(cart, y => y.productId),
				full: true
			}).then(() => setLoading(false));
		}, [cart]);
		
		useEffect(() => {
			window.scrollTo(0, 0);
		}, []);
		
		const {total, products: productList} = extractCartData(cart, products);
		
		const shippingCost = countMap(shipping, (s, k) => {
			if (!s) return 0;
			const vendor = vendors[k];
			if (!vendor) return 0;
			const method = vendor.shipping.find(x => x.id === parseInt(s, 10));
			return method ? parseFloat(method.price) : 0;
		});
		
		return (
			<div id="checkoutWrapper" className="reserveWrapper">
				<BannerHeader bgImage={bgImages} checkout/>
				<div className="checkoutContentWrapper maxWidth">
					
					{loading && <LinearProgress/>}
					
					<RelativeSwitch>
						
						<Route path="brugeroplysninger" render={() =>
							<UserInfo
								products={productList}
								shipping={shippingCost}
								total={total}
								apiCall={apiCall}
								vendors={vendors}
								partyInfo={partyInfo}
							/>
						}/>
						
						<Route path="betalingsoplysninger" render={() =>
							userId ?
								<PaymentInfo
									products={productList}
									total={total}
									shipping={shippingCost}
									history={history}
								/> :
								// User has to be logged in to be able to get to this step, so redirect to previous step
								// just incase something went wrong in the prev step.
								// NOTE: Maybe we want to werify more stuff, like if the partyDate is set, the address is set and things like that..?
								<Redirect to="/reservere/brugeroplysninger"/>
						}/>
						
						<Route path="bekraeftelse" render={() =>
							<Confirmation
								products={productList}
								total={total}
								shipping={shippingCost}
							/>
						}/>
						
						<Route render={() => <Redirect from="/reservere" to="/reservere/brugeroplysninger"/>}/>
					
					</RelativeSwitch>
				</div>
			</div>
		)
	};

const Reserve = reduxWrapper(
	"loadCart",
	"getCacheProduct",
	"getApiCall",
	"loadVendors",
	"loadProducts",
	"getCheckoutCart",
	"getUserId",
	"getPartyInfo"
)(ReserveRender);

const UserInfoRender =
	({
		 products = [],
		 shipping,
		 total,
		 apiCall,
		 vendors,
		 userId,
		 register,
		 setPartyInfo,
		 history,
		 transferParties,
		 partyInfo
	}) => {
		
		// const [addressInfo, setAddressInfo] = useState({});
		const [userInfo, setUserInfo] = useState({});
		const [partyDateTime, setPartyDateTime] = useState(null);
		const [disableStuff, setDisableStuff] = useState(true);
		const [loading, setLoading] = useState(true);
		const [tempAddress, setTempAddress] = useState({});
		const context = useContext(ModalContext);
		const sortedProducts = partitionObject(products, ["product", "vendor"]);
		
		useEffect(() => {
			if (userId) {
				apiCall("GET", "/user/me/address")
					.then(data => data && setUserInfo(p => ({
							...p,
							mainAddress: {
								...p.mainAddress,
								address: data.address,
								zipcode: data.zipcode,
								city: data.city
							}
						}))
					);
				
				apiCall("GET", "/user/me")
					.then(data => data && setUserInfo(p => ({
							...p,
							mainAddress: {
								...p.mainAddress,
								name: data.fullname,
							},
							email: data.email,
							phone: data.phone
						}))
					);
				
				setLoading(false);
			} else {
				setLoading(false);
			}
		}, [userId]);
		
		useEffect(() => {
			setPartyDateTime(partyInfo.time);
		}, [partyInfo]);
		
		useEffect(() => {
			if (!isEmpty(tempAddress)) {
				transferParties();
				setTempAddress({});
				addAddressToUser(tempAddress.mainAddress, tempAddress.phone);
			}
		}, [tempAddress]);
		
		// If the date is unset or less than 8 days from now the "Fortsæt" btn is disabled
		useEffect(() => {
			if (new Date(partyDateTime) - new Date() < (8 * 86400000)) {
				setDisableStuff(true);
			} else {
				setDisableStuff(false);
			}
		}, [partyDateTime]);
		
		const submit = data => {
			submitUserInfo(data, partyDateTime);
		};
		
		const submitUserInfo = ({email, phone, password, mainAddress}, partyDate) => {
			if (loading) return;
			setLoading(true);
			const name = mainAddress.name;
			partyDate = moment.isMoment(partyDate) ? partyDate.format("YYYY-MM-DD HH:mm:ss") : partyDate;
			
			setPartyInfo({
				data: {time: partyDate, reserved: true}
			}).then(() => {
				if (!userId) {
					registerUser(email, name, password, mainAddress, phone)
				} else {
					addAddressToUser(mainAddress, phone);
				}
			})
		};
		
		const goToPayment = () => {
			document.getElementById("address-submit").click();
			window.scrollTo(0, 0);
		}
		
		// Prompt info for userExistsPromt
		const prompt = {
			text: "Denne email er allerede i brug",
			confirm: () => {
				context.toggleModal(false);
				setLoading(false);
			},
			decline: () => {
				context.toggleModal(true, <LoginModal/>);
				setLoading(false);
			},
			confirmText: "Prøv igen",
			declineText: "Gå til log ind"
		};
		
		// If user tires to register with a mail that is allready in the system this prompt modal is run
		const userExistsPromt = () => {
			context.toggleModal(true,
				<PromptModal {...prompt}/>
			)
		};
		
		// Registers a new user and runs the login
		const registerUser = (email, name, password, mainAddress, phone) => {
			register({
				data: {email: email, name: name, password: password},
				success: () => setTempAddress({mainAddress, phone}),
				error: () => userExistsPromt()
			})
		};
		
		// Adds the address and phone number to the user
		const addAddressToUser = (mainAddress, phone) => {
			apiCall("PUT", "/user/me/address", null, mainAddress)
				.then(() => {
					apiCall("PUT", "/user/me", data => {
						setLoading(false);
						history.push("/reservere/betalingsoplysninger");
					}, {phone, fullname: mainAddress.name});
				});
		};
		
		return (
			<Fragment>
				{loading && <LinearProgress/>}
				<h1 className="title-m">Dine oplysninger</h1>
				<StepsSlider pos={1}/>
				
				<div className="checkoutContent">
					<div className="checkoutMainContent">
						<section className="checkoutSection">
							<div className="sectionTitle">
								<h1 className="title-m">Hvornår skal festen holdes?</h1>
								<span className="infoText">Så ved vi hvornår vi skal sende dine varer.</span>
							</div>
							<div className="sectionContent dateContainer">
								<DatetimeInput
									value={partyDateTime}
									onChange={val => setPartyDateTime(val)}
									title={"Vælg dato"}
									req
									placeholder="Vælg dato"
								/>
								{
									//Calculates how far ahed the party is, if its less than 8 days from now, the user has to buy the party right away
									partyDateTime && new Date(partyDateTime) - new Date() < (8 * 86400000) &&
									<div className="buyNowContainer">
										<span>Da der er mindre end 8 dage til din fest kan du købe den nu.</span>
										<div>
											<Button to={"/checkout"}>Køb nu</Button>
										</div>
									</div>
								}
							</div>
						</section>
						
						<section className="checkoutSection">
							<div className="sectionTitle">
								<h1 className="title-m">Dine oplysninger</h1>
							</div>
							<ValidateForm values={userInfo} onChange={setUserInfo} onSubmit={submit}>
								<div id="shippingInfo" className="sectionContent">
									
									{!userId &&
									<span className="infoText">For at reservere din fest skal du oprette en bruger</span>
									}
									
									<FormGroup name="mainAddress">
										<FormInput name="name" title="Navn" req/>
										<FormInput name="address" title="Adresse" req/>
										<div className="postNrAndTown">
											<FormInput name="zipcode" title="Postnr" req/>
											<FormInput name="city" title="By" req/>
										</div>
									</FormGroup>
									
									{/*
									Locking the mail input if the user is logged in, he should not be able to change the user-mail at this point
									Remember that another mail can be used during checkout 8 days before the party is held
								*/}
									
									<FormInput name="email" rules="email" type="email" req locked={!!userId}/>
									<FormInput name="phone" rules="phone" title="Mobil telefon" type="phone" req/>
									
									{!userId &&
									<div className="passwordWrapper">
										<FormInput password={true} name="password"/>
									</div>
									}
								
								</div>
								<Button submit id="address-submit" style={{display: "none"}}/>
							</ValidateForm>
						</section>
						
						<section className="checkoutSection">
							<div className="sectionTitle">
								<h1 className="title-m">Din kurv</h1>
							</div>
							<div id="cartWrapper">
								{mapObjectToArray(sortedProducts, (products, k, i) =>
									<Package
										key={k}
										vendor={vendors[k]}
										products={products}
										options={(vendors[k] || {shipping: []}).shipping}
									/>
								)}
							</div>
						</section>
					</div>
				
					<div className="statusBox">
						<div className="statusBoxContent">
							<div className="statusHeader">
								<h1 className="title-m">Total</h1>
								<img src={CartIcon} alt="Kurv"/>
							</div>
							<PriceSummery total={total} shipping={shipping}/>
						</div>
						<BrowserView renderWithFragment>
							<Button className={disableStuff ? "disabledBtn" : ""}
											onClick={disableStuff ? null : () => goToPayment()}
											>
								Fortsæt med reservation
							</Button>
							<span>eller</span>
							<Button to={"/checkout"}>Køb nu</Button>
						</BrowserView>
						<MobileView renderWithFragment>
							<Button to={"/checkout"}>Køb nu</Button>
							<span>eller</span>
						</MobileView>
					</div>
					<MobileView renderWithFragment>
						<Button 
							className={disableStuff ? "disabledBtn" : ""}
							onClick={disableStuff ? null : () => goToPayment()}
						>
							Fortsæt med reservation
						</Button>
					</MobileView>
				</div>
			</Fragment>
		);
	};

export const UserInfo = reduxWrapper(
	"getRegister",
	"deleteCart",
	"updateCart",
	"setPartyInfo",
	"getTransferParties",
	"getUserId"
)(UserInfoRender);

const PackageRender = ({options, products, deleteCart, updateCart, vendor}) => {
	
	const [showProducts, setShowProducts] = useState(true);
	
	const vendorNameChange = (name) => {
		switch (name) {
			case "Bevco":
				return "Drikkevarer"
			case "Ctiparty":
				return "Dekoration mm."
			case "Alletiders Party Service":
				return "Serviceudlejning"
			case "Kokken og Jomfruen":
				return "Kokken & Jomfruen"
			case "Limofyn":
				return "Limosine"
			case "Euroflorist":
				return "Blomster"
			case "Smageriet":
				return "Smageriet"
			case "Party King":
				return "Diverse "
			case "Lydudlejning":
				return "Lydudlejning"
			default:
				return name;
		}
	}
	
	return (
		<div className="packageContainer">
			<div className="packageTop">
				<div className="endBorder"/>
				<div className="packageTitle">
					<div className="dropBtn" onClick={() => setShowProducts(p => !p)}>
						<img className={showProducts ? "flipped" : ""} src={DropArrowIcon} alt="dropDown"/>
						{/* <span>Pakke {num}</span> */}
						<span>{vendor ? vendorNameChange(vendor.name) : "Pakke"}</span>
					</div>
				</div>
			</div>
			<Collapse in={showProducts}>
				<div>
					{products.map((x, i) =>
						<div key={i} className="footerProductWrapper">
							<div className="prodInfo">
								<img src={getImage(x.product.thumbnail)} alt={x.product.name}/>
								<div className="prodText">
									<span className="prodName">{x.qty} x {x.product.name}</span>
									<span className="prodPrice">A {formatPrice(x.price)} kr</span>
								</div>
							</div>
							
							<div>
								<div className="prodSettings">
									<QtySelector value={x.qty} min={x.section === 9 ? 10 : 1} max={x.product.qty}
									             onChange={val => updateCart({id: x.id, data: {qty: val}})}/>
									<span onClick={() => deleteCart({id: x.id})}>Fjern</span>
								</div>
								<div className="prodTotalPrice">
									<span>{formatPrice(Number(x.price) * x.qty)} kr</span>
								</div>
							</div>
						</div>
					)}
					<span className="shipping">Levering: {options[0] && formatPrice(options[0].price)} kr</span>
				</div>
			</Collapse>
		</div>
	);
};
export const Package = reduxWrapper("deleteCart", "updateCart")(PackageRender);

const PaymentInfoRender = ({products, total, shipping, history, apiCall}) => {
	
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	
	const onSaveCard = (card) => {
		setLoading(true);
		apiCall("POST", "/user/me/cards", () => {
			setLoading(false);
			history.push("/reservere/bekraeftelse");
		}, card, error => {
			setError(true);
			setLoading(false);
		});
	};
	
	return (
		<Fragment>
			{loading && <LinearProgress/>}
			<h1 className="title-m">Betalingsoplysninger</h1>
			<StepsSlider pos={2}/>
			
			<div className="checkoutContent cardContent">
				<div className="checkoutMainContent">
					<section className="checkoutSection">
						<div className="sectionTitle">
							<h1 className="title-m">Reserver</h1>
						</div>	
						<div className="sectionContent cardInfo">
							{error && <span className="error">Det ser ud til du tastede forkert. Prøv igen.</span>}
							<ValidateForm onSubmit={(data) => {
								onSaveCard(data);
								window.scrollTo(0, 0);
							}}>
								<FormInput name="cardNumber" title="Kortnummer" req/>
								<FormInput name="expiry" title="Udløbsdato(MM/YY)" req formatChange={formatExpiry}/>
								<FormInput name="cvs" title="CVS Kode" req/>
								<div className="paySection">
									<Checkbox
										name="tos"
										title={
											<Fragment>Jeg accepterer
												<a target="_blank" href={"/info/handelsbetingelser"}> Handelbetingelserne</a>
											</Fragment>
										}
									/>
									<Button id="reserve-submit" className="btnGreen" submit style={{display: "none"}}>Reserver din fest</Button>
								</div>
							</ValidateForm>
							<div className="sslContainer">
								<img src={SslIcon} alt="SSL"/>
								<p>
									Dine betalings oplysninger er sikret med en SSL kryptering, den sikreste
									på marked. Der sikre at dine kort oplysninger ikke vil blive tilgænge
									for andre.
								</p>
							</div>
						</div>
					</section>

					<section className="checkoutSection">
						<div className="sectionTitle">
							<h1 className="title-m">Overblik</h1>
						</div>
						<div className="sectionContent">
							{products.map((x, i) =>
								<div key={i} className="footerProductWrapper">
									<div className="prodInfo">
										<img src={getImage(x.product.thumbnail)} alt={x.product.name}/>
										<div className="prodText">
											<span
												className="prodName">{x.qty || x.qtyOrdered || 0} x {x.product.name}</span>
											<span className="prodPrice">{formatPrice(x.price)}</span>
										</div>
									</div>
									<div className="prodTotalPrice">
										<span>{formatPrice(Number(x.price) * (x.qty || x.qtyOrdered || 0))} kr</span>
									</div>
								</div>
							)}
						</div>
					</section>
				</div>
			
				<div className="statusBox">
					<div className="statusBoxContent">
						<div className="statusHeader">
							<h1 className="title-m">Total</h1>
							<img src={CartIcon} alt="Kurv"/>
						</div>
						<PriceSummery total={total} shipping={shipping}/>
					</div>
					<BrowserView renderWithFragment>
						<Button onClick={() => document.getElementById("reserve-submit").click()}>
							Reserver din fest
						</Button>
					</BrowserView>
				</div>
				<MobileView renderWithFragment>
					<Button onClick={() => document.getElementById("reserve-submit").click()}>
						Reserver din fest
					</Button>
				</MobileView>
			</div>

		</Fragment>
	)
};

const PaymentInfo = reduxWrapper("getApiCall")(PaymentInfoRender);

const ConfirmationRender = ({products, total, shipping, setPartyInfo}) => {
	const context = useContext(ModalContext);
	
	const prompt = {
		text: "Vil du annullere din reservation?",
		confirm: () => {
			setPartyInfo({
				data: {reserved: false}
			}).then(() => {
				context.toggleModal(false);
			})
		},
		decline: () => {
			context.toggleModal(false);
		},
		confirmText: "Ja",
		declineText: "Nej"
	};
	
	return (
		<Fragment>
			<h1 className="title-m">Bekræftelse</h1>
			<StepsSlider pos={3}/>
			
			
			
			<div className="checkoutContent reserveConfirm">
				<div className="checkoutMainContent">
					<section className="checkoutSection">
						<div className="sectionTitle">
							<h1 className="doneTitle title-m">Din reservation</h1>
						</div>
						<div className="sectionContent">
							{products.map((x, i) =>
								<div key={i} className="footerProductWrapper">
									<div className="prodInfo">
										<img src={getImage(x.product.thumbnail)} alt={x.product.name}/>
										<div className="prodText">
											<span
												className="prodName">{x.qty || x.qtyOrdered || 0} x {x.product.name}</span>
											<span className="prodPrice">{formatPrice(x.price)}</span>
										</div>
									</div>
									<div className="prodTotalPrice">
										<span>{formatPrice(Number(x.price) * (x.qty || x.qtyOrdered || 0))} kr</span>
									</div>
								</div>
							)}
						</div>
					</section>
				</div>
			
				<div className="statusBox">
					<div className="confirmBox">
						<img src={CheckWhiteIcon} alt="Gennemført"/>
						<h1>Reserveret</h1>
					</div>
					<div className="statusBoxContent">
						<div className="statusHeader">
							<h1 className="title-m">Total</h1>
							<img src={CartIcon} alt="Kurv"/>
						</div>
						<PriceSummery total={total} shipping={shipping}/>
					</div>
					<Button onClick={() => context.toggleModal(true, <PromptModal {...prompt}/>)}>Annulere</Button>
					<Button to={"/checkout"}>Køb nu</Button>
					<Button to={"/minfest"}>Din fest</Button>
				</div>
			
			</div>


		</Fragment>
	)
}
const Confirmation = reduxWrapper("setPartyInfo")(ConfirmationRender);

const StepsSlider = ({pos}) => {
	const [showInfo, setShowInfo] = useState(isMobileOnly ? false : true);
	
	return (
		<div className="stepsWrapper">
			<div className="stepsContainer">
				<div className="textContainer">
					{mapObjectToArray(steps, (x, k) => (
						<div className={"milestone" + (pos < k ? " fade" : "")} key={k}>
							<span>{k}</span>
							<span>. {x}</span>
						</div>
					))}
				</div>
				
				<div className="ringsContainer">
					{mapObjectToArray(steps, (x, k) => (
						<Fragment key={k}>
							<div className={"circkleWrapper" + (pos > k ? " done" : (pos < k ? " fade" : ""))}>
								{pos > k && <img src={CheckWhiteIcon} alt="Check"/>}
							</div>
							{k < objLength(steps) && <div className={"connectorLine" + (pos <= k ? " fade" : "")}/>}
						</Fragment>
					))}
				</div>
			</div>
			
			
			<div style={{backgroundColor: "white"}}>
				<div className="checkoutInfoWrapper">
					
					{pos === 2 &&

					<div className="confirmTitle">		
						<p>
							Reserver din fest i dag og betal først 8 dage før festen skal afholdes.
							Fordel ved at reservere en fest er at du uforpligtende kan finpudse din fest lige indtil 8
							dage før. Hvor vi senest skal have den endelige bestilling.
						</p>
					</div>
					}
					
					{pos === 3 &&
					<div className="confirmTitle">
						<h1 className="title-m">Tillykke din fest er nu reserveret!</h1>
						<p>
							Du har mulighed for at ændre din reservation helt op til 8 dage før festen skal afholdes.
							Når alt er timet og tilrettelagt kan ordren gennemføres ved at gå til betaling.
						</p>
					</div>
					}
					
					{pos !== 3 && isMobile &&
					<div className="checkoutInfoTitle infoTitle" onClick={() => setShowInfo(p => !p)}>
						<h1 className="title-m">Info</h1>
						<img className={showInfo ? "flipped" : ""} src={DropArrowIcon} alt="dropDown"/>
					</div>
					}
					
					<Collapse in={showInfo}>
						<div className="posInfographic">
							<div className="graphicStep">
								<img src={kalendarGreenIcon} alt="Reserver"/>
								<span>Når du reservere din fest, kan du stadig rette den helt op til 8 dage før festen afholdes.</span>
							</div>
							<div className="graphicStep">
								<img src={cardrGreenIcon} alt="Betalingsoplysninger"/>
								<span>Betal senest 8 dage før festen. Vi sørger for at  dine varer bliver leveret  i forhold til dine ønsker.</span>
							</div>
							<div className="graphicStep">
								<img src={fragtGreenIcon} alt="Bekræftelse"/>
								<span>Mad leveres på dagen, andre varer leveres 1-5 dage før festen.</span>
							</div>
						</div>
					</Collapse>
				</div>
			</div>
		</div>
	)
};

export const PriceSummery = ({total, shipping}) => (
	<div className="priceSummary">
		<div className="subTotal">
			<span>Subtotal</span>
			<span>{formatPrice(total - total * 0.2)} kr</span>
		</div>
		
		<div className="shipping">
			<span>Levering</span>
			<span>{formatPrice(shipping)} kr</span>
		</div>
		
		<div className="moms">
			<span>Moms</span>
			<span>{formatPrice(total * 0.2)} kr</span>
		</div>
		
		<div className="total">
			<span>I alt</span>
			<span>{formatPrice(Number(total) + Number(shipping))} kr</span>
		</div>
	</div>
);

const formatExpiry = (value) => {
	return (value || "")
		.replace(/[^\d/]/, "")
		.replace(/(\d\d)(\d\d?)/, "$1/$2")
		.substr(0, 5);
};

// const CardBox = ({onSubmit, total, shipping, error}) => {
// 	const cardSubmit = (data) => {
// 		//if (data && data.tos) onSubmit(data);
// 		//else alert("Venligst accepter vores TOS");
// 		onSubmit(data);
// 	};
	
// 	return (
// 		<div id="cardInfoContent">
// 			<div className="cardInfoHeader">
// 				<h1 className="title-m">Reserver</h1>
// 				<img src={KortIcon} alt="cards"/>
// 			</div>
// 			{error && <span className="error">Det ser ud til du tastede forkert. Prøv igen.</span>}
// 			<ValidateForm onSubmit={(data) => {
// 				cardSubmit(data);
// 				window.scrollTo(0, 0);
// 			}}>
// 				<FormInput name="cardNumber" title="Kortnummer" req/>
// 				<div className="cardInfoLower">
// 					<FormInput name="expiry" title="Udløbsdato(MM/YY)" req formatChange={formatExpiry}/>
// 					<FormInput name="cvs" title="CVS Kode" req/>
// 				</div>
// 				<PriceSummery total={total} shipping={shipping}/>
// 				<div className="paySection">
// 					<Checkbox
// 						name="tos"
// 						title={
// 							<Fragment>Jeg accepterer
// 								<a target="_blank" href={"/info/handelsbetingelser"}> Handelbetingelserne</a>
// 							</Fragment>
// 						}
// 					/>
// 					<Button className="btnGreen" submit>Reserver din fest</Button>
// 				</div>
// 			</ValidateForm>
// 			<div className="sslContainer">
// 				<img src={SslIcon} alt="SSL"/>
// 				<p>
// 					Dine betalings oplysninger er sikret med en SSL kryptering, den sikreste
// 					på marked. Der sikre at dine kort oplysninger ikke vil blive tilgænge
// 					for andre.
// 				</p>
// 			</div>
// 		</div>
// 	);
// };

export default Reserve;


// WEBPACK FOOTER //
// ./src/components/views/reserve.js